export default __webpack_public_path__ + "static/terminal-presintation_kz-ebc287a6fec0c1149d52ed270c47b679.png";